/**
 * Campusio Logo Component
 * Original logo design with book/document symbol
 */

export const LogoIcon = ({ size = 40, className = '' }) => {
  return (
    <svg
      viewBox="0 0 40 40"
      width={size}
      height={size}
      className={`logo-icon ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="8" width="32" height="24" rx="2" fill="currentColor" opacity="0.2"/>
      <rect x="8" y="12" width="24" height="16" rx="1" fill="currentColor"/>
      <path d="M20 18l8-4v12l-8 4-8-4V14l8 4z" fill="white"/>
    </svg>
  );
};

export const LogoWithText = ({ size = 40, className = '' }) => {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div style={{ color: '#064E3B' }}>
        <LogoIcon size={size} />
      </div>
      <span className="font-bold text-[#064E3B] tracking-tight" style={{ fontSize: size * 0.6 }}>
        Campusio
      </span>
    </div>
  );
};

export default LogoIcon;

